import React, { useEffect } from 'react'
import { FormProvider, useForm } from 'react-hook-form'

import { BigCalendarModalBodyIndividual } from './components/modal/BigCalendarModalBodyIndividual'
import {
  BigCalendarModalFooterIndividual,
  BigCalendarModalFooterIndividualProps,
} from './components/modal/BigCalendarModalFooterIndividual'
import { computeHouseAvailabilityIndividualDefaultValues } from './helpers/compute-house-availability-individual'
import { BigCalendarProps } from '../shared/calendar/BigCalendar'
import { BigCalendarContainer } from '../shared/calendar/components/container/BigCalendarContainer'
import { BigCalendarHeaderICalendarImportProps } from '../shared/calendar/components/header/components/BigCalendarHeaderImportButton'
import {
  BigCalendarModalIndividualFormProps,
  useBigCalencarFormContext,
} from '../shared/calendar/utils/use-big-calendar-form'

export const BigCalendarIndividual = ({
  house,
  onUpdateICalendarUrls,
  onUpsertHouseAvailability,
  onUpsertManyHouseAvailabilities,
  isFormDisabled,
}: Pick<BigCalendarHeaderICalendarImportProps, 'onUpdateICalendarUrls'> &
  Pick<BigCalendarProps, 'house'> &
  Pick<
    BigCalendarModalFooterIndividualProps,
    | 'onUpsertHouseAvailability'
    | 'onUpsertManyHouseAvailabilities'
    | 'isFormDisabled'
  >) => {
  const { modalFormProps } = useBigCalencarFormContext()

  const hasError =
    !modalFormProps ||
    !modalFormProps.formValues ||
    modalFormProps?.kind !== 'individual'

  const methods = useForm<BigCalendarModalIndividualFormProps>({
    ...(hasError ? {} : { defaultValues: modalFormProps }),
  })
  const { reset } = methods

  useEffect(() => {
    if (!hasError) {
      reset(computeHouseAvailabilityIndividualDefaultValues(modalFormProps))
    }
  }, [modalFormProps?.formValues])

  return (
    <FormProvider {...methods}>
      <BigCalendarContainer
        house={house}
        onUpdateICalendarUrls={onUpdateICalendarUrls}
        modalContent={{
          body: (
            <BigCalendarModalBodyIndividual isFormDisabled={isFormDisabled} />
          ),
          footer: (
            <BigCalendarModalFooterIndividual
              isFormDisabled={isFormDisabled}
              onUpsertHouseAvailability={onUpsertHouseAvailability}
              onUpsertManyHouseAvailabilities={onUpsertManyHouseAvailabilities}
            />
          ),
        }}
      />
    </FormProvider>
  )
}
